import React from 'react';
import withAppState from '../../../mobx/withAppState'
import SplitBillName from '../../../components/SplitBillName';
import { getCsrfToken } from '../../../helpers/GetCsrfToken';

const MiPayAtTableSplitBillNameWrapper = (props) => {
  const { splitBillSessionToken, customer, restaurant, tableNumber, bill } = props;
 
  const handleBackButton = () => {
    props.popStep();
  }

  const assignName = async (inputName) => {
   
    if (inputName.length !== 2) {
      return;
    }
   
    const response = await fetch(`api/Bill/AssignName/${bill[0].providerId}/${restaurant.id}/${tableNumber}`,
      {
        
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-XSRF-TOKEN': getCsrfToken()
        },
        body: JSON.stringify({
          Name: inputName,
          SplitBillSessionToken: splitBillSessionToken,
          PizzaExpressId:
            !!customer && !!customer.id
              ? customer.id
              : null
        })
      }
    );

    if (!response.ok) {
      props.setErrorModalMessage(
        'There was a problem joining this split.'
      );
      return;
    }
    let data;
    try {
      data = await response.json();
    } catch (err) {
      props.setErrorModalMessage(
        'There was a problem joining this split.'
      );
      return;
    }

    const { success, bills, responseValues } = data;
    if (success === true) {
      props.setBill(bills);
      if (
        !!responseValues &&
        !!responseValues['splitIndex']
      ) {
        var newSplitIndex = Number(responseValues['splitIndex']);
        if (newSplitIndex >= 0) {
          props.setSelectedSplitIndex(newSplitIndex);
          props.setAssignedSplitIndex(newSplitIndex);
        }
      }
    } else {
      props.setErrorModalMessage(
        'There was a problem joining this split.'
      );
    }
    props.popStep();
  }

  return <SplitBillName handleBackButton={handleBackButton} assignName={assignName} />
}


export default withAppState(MiPayAtTableSplitBillNameWrapper,
  {
    mobXProps: ({
      splitBillSessionToken,
      customer,
      restaurant,
      tableNumber,
      bill,
    }) => ({
      splitBillSessionToken,
      customer,
      restaurant,
      tableNumber,
      bill
    }),
    mobXActions: ({
      setBill,
      setSelectedSplitIndex,
      setAssignedSplitIndex,
      setErrorModalMessage,
      popStep,
      getCurrency
    }) => ({
      setBill,
      setSelectedSplitIndex,
      setAssignedSplitIndex,
      setErrorModalMessage,
      popStep,
      getCurrency
    })
  }
);